import React, { Fragment, useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Input } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DataTable from "react-data-table-component";
import Spinner from "../../Components/Common/Spinner";
import NoDataFound from "../../Components/Common/NoDataFound";
import AxiosInstance from "../../services/AxiosInstance";
import { formatDate } from "../../Components/Common/CommonFunction";
import { customStyles } from "../../Constant";

const CustomHeader = ({ cell }) => (
  <th style={{ fontWeight: "bold" }}>{cell.label}</th>
);

const ReferredUsersPage = () => {
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [direction, setDirection] = useState("DESC");

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await AxiosInstance().post("/jobseeker/referredUsersList", {
        page: currentPage,
        per_page: perPage,
        search: search,
        sort_by: sortBy,
        direction: direction,
      });
      if (response.data && response.data.status) {
        setData(response.data.data || []);
        setTotalRows(response.data.total || 0);
      } else {
        setData([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error(error);
      setData([]);
      setTotalRows(0);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, [currentPage, perPage, sortBy, direction]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        fetchUsers();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const handlePageChange = (page) => setCurrentPage(page);
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };
  const handleSort = (column, sortDirection) => {
    if (column.short_column) {
      setSortBy(column.short_column);
      setDirection(sortDirection.toUpperCase());
    }
  };

  const columns = [
    {
      name: "#",
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      sortable: false,
    },
    {
      name: "Name",
      selector: row => row.name,
      sortable: true,
      short_column: "name"
    },
    {
      name: "Email",
      selector: row => row.email,
      sortable: true,
      short_column: "email"
    },
    {
      name: "Phone",
      selector: row => row.phone || "-",
      sortable: true,
      short_column: "phone"
    },
    {
      name: "User Type",
      selector: row => row.user_type || "-",
      sortable: true,
      short_column: "user_type"
    },
    {
      name: "Created At",
      selector: row => row.created_at ? formatDate(row.created_at) : "-",
      sortable: true,
      short_column: "created_at"
    }
  ];

  return (
    <Fragment>
      <Breadcrumbs title="Referred Users List" mainTitle="Referred Users" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="px-0 py-3">
                <div className="d-flex justify-content-end mb-3 px-3">
                  <Input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ width: "250px" }}
                  />
                </div>
                <DataTable
                  customStyles={customStyles}
                  data={data}
                  columns={columns}
                  keyField="email"
                  striped={true}
                  center={true}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={perPage}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                  headerComponent={CustomHeader}
                  progressPending={isLoading}
                  progressComponent={<Spinner />}
                  noDataComponent={<NoDataFound message={"No Data Found"} />}
                  onSort={handleSort}
                  sortServer
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ReferredUsersPage;
